<app-loader [isLoading]="isLoading"></app-loader>

<div class="header">
  <div class="top">
    <a routerLink="/home/communication/activities">
      <h3>Buzón /</h3>
      <div class="breadcrumb">
        <mat-icon svgIcon="arrow back"></mat-icon>
        <h2>Añadir actividad</h2>
      </div>
    </a>
  </div>
</div>
<div class="content form">
  <form [formGroup]="activityForm">
    <h4>Título:</h4>
    <mat-form-field appearance="outline" id="title-form-field">
      <input type="text" matInput placeholder="Título" formControlName="title" />
      @if (activityForm.get('title')?.invalid &&
      activityForm.get('title')?.touched) {
      <mat-error> El título es requerido </mat-error>
      }
    </mat-form-field>
    <h4>Descripción:</h4>
    <quill-editor formControlName="description" [modules]="modules" [styles]="{ height: '300px' }"></quill-editor>
    @if (activityForm.get('description')?.invalid &&
    activityForm.get('description')?.touched) {
    <div class="error-message">La descripción es requerida</div>
    }

    <div class="dates">
      <h4>Fechas:</h4>
      <!-- Botón para añadir nueva fecha -->
      <button mat-icon-button color="primary" (click)="addNewDate()" class="add-date-button">
        <mat-icon>add</mat-icon>
      </button>
    </div>
    @if (showDateError) {
    <div class="error-message">
      <mat-error>Una fecha mínimo obligatorio</mat-error>
    </div>
    }
    <!-- Sistema de múltiples fechas con @for -->
    @for (day of event.event_days; track day.id) {
    <div class="date-field-container">
      <mat-form-field appearance="outline" style="margin-right: 10px;">
        <mat-label>Fecha</mat-label>
        <input matInput [matDatepicker]="dp" [(ngModel)]="day.date" [ngModelOptions]="{ standalone: true }"
          (dateChange)="onDateChange(day, $event)" />
        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
        <mat-datepicker #dp></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" style="margin-right: 10px;">
        <mat-label>Hora inicio</mat-label>
        <input matInput type="time" [(ngModel)]="day.start_time" [ngModelOptions]="{ standalone: true }"
          (change)="onTimeChange(day, 'start')" />
        <mat-icon matSuffix>access_time</mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Hora fin</mat-label>
        <input matInput type="time" [(ngModel)]="day.end_time" [ngModelOptions]="{ standalone: true }"
          (change)="onTimeChange(day, 'end')" />
        <mat-icon matSuffix>access_time</mat-icon>
      </mat-form-field>

      <button mat-icon-button color="warn" (click)="removeEventDay(day.id)" class="delete-button">
        <mat-icon svgIcon="delete"></mat-icon>
      </button>
    </div>
    }

    <div class="options-row">
      <mat-checkbox formControlName="featured">Destacado</mat-checkbox>

      <mat-checkbox formControlName="notifications">Notificaciones</mat-checkbox>

      <mat-checkbox formControlName="isProgrammed">Programada</mat-checkbox>
    </div>

    @if (isProgrammed) {
    <br /><br /><br />
    <mat-form-field appearance="outline" style="margin-right: 10px;">
      <mat-label>Fecha</mat-label>
      <input matInput [matDatepicker]="datepicker" formControlName="dateValue" />
      <mat-datepicker #datepicker />
      <mat-datepicker-toggle [for]="datepicker" matSuffix />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Hora</mat-label>
      <input matInput type="time" formControlName="timeValue" />
      <mat-icon matSuffix>access_time</mat-icon>
    </mat-form-field>

    <p>Fecha y hora programada: {{ getFormattedDateTime() }}</p>
    }
    <h4>Tags:</h4>
    <mat-form-field style="width: 50%" appearance="outline">
      <input matInput formControlName="tags" placeholder="Etiquetas separadas por comas" />
    </mat-form-field>

    <!-- <h4>Ubicación:</h4>
    <mat-form-field style="width: 50%" appearance="outline">
      <input matInput formControlName="location" placeholder="Ubicación de la actividad" />
    </mat-form-field> -->

    <h4>Link:</h4>
    <mat-form-field style="width: 50%" appearance="outline">
      <input matInput formControlName="registration_link" placeholder="ejemplo.com o https://ejemplo.com" />
      @if (activityForm.get('registration_link')?.invalid && activityForm.get('registration_link')?.touched) {
      <mat-error>
        Por favor, ingrese una URL válida (ej: ejemplo.com, https://ejemplo.com)
      </mat-error>
      }
      @if (activityForm.get('registration_link')?.valid && activityForm.get('registration_link')?.value &&
      activityForm.get('registration_link')?.value.trim() !== '') {
      <mat-hint style="color: green;">
        <mat-icon style="font-size: 16px; vertical-align: middle;">check_circle</mat-icon>
        URL válida
      </mat-hint>
      }
      @if (!activityForm.get('registration_link')?.value || activityForm.get('registration_link')?.value.trim() === '')
      {
      <mat-hint>
        Opcional - Enlace para inscripción o más información
      </mat-hint>
      }
    </mat-form-field>
  </form>
  <br>
  <h4>Imagen de la actividad:</h4>
  <app-upload-files [singleFile]="true" (filesSelected)="onFileSelected($event)"></app-upload-files>
  <br />

  <div class="buttons">
    <button mat-flat-button id="action" (click)="saveChanges()">
      Guardar cambios
    </button>
    <button mat-flat-button id="cancel" routerLink="/home/communication/activities">
      Cancelar
    </button>
  </div>
</div>